import CalendarBookingEmpVela from './CalendarBookingEmpVela.vue'

export default {
  CalendarBookingEmpVela
}



// WEBPACK FOOTER //
// ./src/components/Vela/index.js